// Imports
import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { Route, Redirect } from 'react-router-dom'
import { connect } from 'react-redux'
import { checkPermission } from "../common/Sidebar/checkPermission";
import routes from '../user/api/routes'

// Component
const RoutePrivate = (props) => {
  const [hasPermission, setHasPermission] = useState(null);
  useEffect(() => {
    // console.log("Inside useEffect()")
    const verifyPermission = async () => {
      // console.log("Inside verifyPermission(): ", props)
      if (props.role) {
        // console.log("Hitttt")
        const permissionGranted = await checkPermission( props.module, props.subModule, props.action );
        setHasPermission(permissionGranted);
      } else {
        setHasPermission(true);
      }
    };
    // console.log("Calling verifyPermission() ")
    verifyPermission();
  }, [props.role, props.module, props.subModule, props.action]);

  if (hasPermission === null) {
    return <div>Loading...</div>;
  }

  const isResourceEnabled = props.settings?.isResourceEnabled ?? true;
  const isAccessible = props.requiresResourceEnabled ? (hasPermission && isResourceEnabled) : hasPermission;

  return props.auth.isAuthenticated ? (
    isAccessible ? (
      <Route {...props} component={props.component} />
    ) : (
      <Redirect to={routes.userLogin.path}/>
    )
  ) : (
    <Redirect to={routes.userLogin.path}/>
  )
}

// Component Properties
RoutePrivate.propTypes = {
  auth: PropTypes.object.isRequired,
  role: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  module: PropTypes.string.isRequired,
  subModule: PropTypes.string,
  action: PropTypes.string,
};

// Component State
function routePrivateState(state) {
  return {
    auth: state.auth,
    settings: state.settings?.settings
  }
}

export default connect(routePrivateState, {})(RoutePrivate);
